import { Component, signal, ViewChild } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { TabsModule } from 'primeng/tabs';
import { ConfigTemplates } from '../config-templates/config-templates';
import { NotificationHistory } from '../notification-history/notification-history';
import { SendNotification } from '../../../@shared/forms/topics/send-notification/send-notification';

@Component({
  selector: 'app-topics-page',
  imports: [ButtonModule, TabsModule, ConfigTemplates, NotificationHistory, SendNotification],
  templateUrl: './topics-page.html',
  styleUrl: './topics-page.scss',
})
export class TopicsPage {
  @ViewChild(ConfigTemplates) configTemplates!: ConfigTemplates;
  @ViewChild(NotificationHistory) notificationHistory!: NotificationHistory;

  activeTab = signal('0');
  sendNotificationDialog = false;

  onTabChange(value: string | number) {
    this.activeTab.set(value.toString());
    if (value.toString() === '1') this.notificationHistory?.init();
  }

  onNotificationSent() {
    if (this.activeTab() === '1') {
      this.notificationHistory?.refresh();
    }
  }

  onAddClick() {
    if (this.activeTab() === '0') {
      this.configTemplates?.openAdd();
    }
  }
}
